import proptypes from 'prop-types';

const {
  bool, node, number, string, func, shape
} = proptypes;

export const RatingsAndReviewsPropTypes = {
  /*
    This is a bad practice.
    APIs should not be called directly.
    There is a story to refactor this to use a graphql mutation:
    https://www.pivotaltracker.com/story/show/173363061
  */
  apiKey: string,
  children: node,
  collectionId: string,
  itemId: string,
  prosAndCons: bool,
  forceCondensedLayout: bool,
  target: string,
  seoPageNumber: number,
  disableOverlayOnClick: bool,
  isUsingAccordion: bool,
  pprPageReturn: func,
  searchAndSortRef: shape({ current: shape({ scrollIntoView: func }) }),
  selectedReviewSummaryAspect: string,
  onAspectClick: func,
  forceMobile: bool,
  productLabel: string,
  showProductAttribution: bool,
  originalProductName: string
};

export const StoreRatingsAndReviewsPropTypes = {
  apiKey: string,
  children: node,
  collectionId: string,
  storeId: string,
  prosAndCons: bool,
  forceCondensedLayout: bool,
  target: string,
  seoPageNumber: number,
  seoStoreLink: string
};
